import React from "react";
import "./GameArea.scss";
import {SnookerGame} from "./SnookerGame";
import Hud from "./components/Hud/Hud";
import EndOfFrame from "./components/Hud/EndOfFrame";

export class GameArea extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        return <>
            <div style={{flex: "1 1 auto", overflow: "hidden"}}>
                <div id="anaglyph-button"></div>
                <SnookerGame>
                    <Hud/>
                    <EndOfFrame/>
                </SnookerGame>
            </div>
            <div id="info"></div>

            {/*<div id="invite-message" style={{display:"none"}}>*/}
            {/*    <span id="username"></span> is inviting you to a game. Would you like to accept it?*/}
            {/*</div>*/}
        </>
    }
}